'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
export default function UIAbstractPageSection(props) {
  var className = props.className,
      rest = _objectWithoutProperties(props, ["className"]);

  return React.createElement("section", Object.assign({}, rest, {
    className: classNames('private-template__section', className)
  }));
}
UIAbstractPageSection.propTypes = {
  children: PropTypes.node
};
UIAbstractPageSection.displayName = 'UIAbstractPageSection';